import * as React from 'react';

export default function IconConnectWithFacebook({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      className={className}
    >
      <rect width="24" height="24" fill="#fff" rx="2" />
      <path
        fill="#1877F2"
        d="M23 12c0-6-5-11-11-11S1 6 1 12a11 11 0 0 0 9.3 11v-7.7H7.5V12h2.8V9.6c0-2.7 1.6-4.3 4.1-4.3l2.5.2v2.8h-1.4c-1.4 0-1.8.8-1.8 1.7v2h3l-.4 3.3h-2.6V23A11 11 0 0 0 23 12Z"
      />
    </svg>
  );
}
